// Main steps for the recommendation wizard
export const STEPS = ["Welcome", "Your Kitty", "Goals", "Preferences"];

// Substeps mapping for each main step
export const SUBSTEPS = {
    kitty: ["Age", "Breed"],
    goals: ["Food Type", "Diet Goals"],
    preferences: ["Proteins", "Texture", "Brand", "Products"]
};

// Constants that were undefined in the original code
const BREED_OPTIONS = [
    "Abyssinian",
    "American Bobtail",
    "American Curl",
    "American Shorthair",
    "American Wirehair",
    "Balinese",
    "Bengal",
    "Birman",
    "Bombay",
    "British Longhair",
    "British Shorthair",
    "Burmese",
    "Burmilla",
    "Chartreux",
    "Chinese Li Hua",
    "Colorpoint Shorthair",
    "Cornish Rex",
    "Cymric",
    "Devon Rex",
    "Egyptian Mau",
    "European Burmese",
    "Exotic Shorthair",
    "Havana Brown",
    "Himalayan",
    "Japanese Bobtail",
    "Javanese",
    "Khao Manee",
    "Korat",
    "LaPerm",
    "Maine Coon",
    "Manx",
    "Mixed Breed",
    "Munchkin",
    "Nebelung",
    "Norwegian Forest Cat",
    "Ocicat",
    "Oriental",
    "Persian",
    "Peterbald",
    "Pixiebob",
    "Ragamuffin",
    "Ragdoll",
    "Russian Blue",
    "Savannah",
    "Scottish Fold",
    "Selkirk Rex",
    "Siamese",
    "Siberian",
    "Singapura",
    "Snowshoe",
    "Somali",
    "Sphynx",
    "Tonkinese",
    "Toyger",
    "Turkish Angora",
    "Turkish Van",
];

export const BREED_OPTIONS_GROUPED = [
    {
        label: "Special Options",
        options: [
            { label: "Don't know", value: "Don't know" },
            { label: "Other", value: "Other" },
        ],
    },
    {
        label: "Breeds",
        options: BREED_OPTIONS.map((breed) => ({
            label: breed,
            value: breed,
        })),
    },
];

export const GOALS_OPTIONS = [
    {
        key: "explore",
        label: "Explore new flavors & textures",
        comment: "Recommend novel tastes and textures to expand your cat’s palate",
    },
    {
        key: "similar",
        label: "Find similar alternatives to current food",
        comment: "Recommend products similar in ingredients and format to what your cat already likes",
    },
    {
        key: "budget",
        label: "Stay on budget",
        comment: "This is an experimental option: let us know if budget is a priority for you",
    },
    {
        key: "kidney",
        label: "Support kidney health",
        comment: "Recommend low-phosphorus formulas (< 0.7%) to support kidney function",
    },
    {
        key: "hydration",
        label: "Boost hydration",
        comment: "Recommend foods with high moisture to keep your cat well-hydrated",
    },
    {
        key: "weight",
        label: "Manage weight",
        comment: "Recommend high-protein, lower-carb options for healthy weight control",
    }    
];